import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { getExtraWorkOrderStatusConfig } from '../../../List/config/extraWorkOrderStatusConfig';
import type { ExtraWorkOrder } from '../../../List/models';

interface BreadcrumbProps {
  order: ExtraWorkOrder | null;
}

/**
 * Breadcrumb - Navegación de breadcrumb para detalle de orden de trabajo extra
 *
 * Componente de navegación que muestra la ruta actual en el detalle
 * de una orden de trabajo extra. Incluye:
 * - Navegación a la lista de trabajos extra
 * - Información de la referencia y estado de la orden
 * - Estilos consistentes con el diseño del sistema
 */
export const Breadcrumb = ({ order }: BreadcrumbProps) => {
  const { t } = useTranslation('extraWorkOrdersModule');

  const breadcrumbs = useMemo(() => {
    if (!order) {
      return [{ label: t('title', 'Trabajos Extra'), path: '/extra-work-orders' }, { label: '...' }];
    }

    const statusConfig = getExtraWorkOrderStatusConfig(order.status);

    return [
      { label: t('title', 'Trabajos Extra'), path: '/extra-work-orders' },
      {
        label: (
          <div className="flex items-center gap-2">
            <span className="text-title">{order.ref}</span>
            <span
              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${statusConfig.bg} ${statusConfig.text}`}
            >
              {t(`status.${order.status}`, statusConfig.label)}
            </span>
          </div>
        ),
      },
    ];
  }, [t, order]);

  usePageNavigation({ breadcrumbs });

  return null;
};
